<script>
export default {
  name: 'NotificationCheckbox',
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
  },
  methods: {
    toggle() {
      this.$emit('change', !this.checked)
    },
  },
}
</script>

<template>
  <div class="mc-notification-setting__status-item" @click="toggle">
    <div role="checkbox" :aria-checked="checked" class="mc-notification-setting__checkbox"
      :class="{ 'mc-notification-setting__checkbox--checked': checked }">
      <i v-if="checked" class="bx bx-check mc-notification-setting__checkbox-icon" />
    </div>

    <span v-if="label" class="mc-notification-setting__status-label">
      {{ label }}
    </span>
  </div>
</template>
